import React, { useEffect, useState } from 'react';
import { Card, Button, Modal, Spinner } from 'react-bootstrap';
import {
  FaCloudUploadAlt,
  FaFileCsv,
  FaDownload,
  FaSyncAlt,
  FaCheckCircle,
  FaExclamationCircle,
  FaDatabase,
} from 'react-icons/fa';
import { CSVLink } from 'react-csv';
import resumensinc from '../../api/apiweb-resumensinc.js';
import reload from '../../api/apiweb-reloadcsv.js';
import './resumenSinc.scss';

function Resumensinc() {
  const [formattedData, setformattedData] = useState(null);
  const [modalDescarga, setModalDescarga] = useState(false);
  const [spinner, setSpinner] = useState(false);
  const [modalMensaje, setModalMensaje] = useState('');
  const [csvPendientesSinError, setcsvPendientesSinError] = useState(null);
  const [csvPendientesConError, setcsvPendientesConError] = useState(null);
  const [csvFaltantesbd, setcsvFaltantesbd] = useState(null);
  const [file, setFile] = useState(null);
  const [dragging, setDragging] = useState(false);
  const hiddenFileInput = React.useRef(null);

  const handleFileChange = (event) => setFile(event.target.files[0]);
  const handleClick = () => hiddenFileInput.current.click();
  const closeModal = () => setModalDescarga(false);

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };
  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragging(false);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    const dropped = e.dataTransfer.files[0];
    if (dropped && dropped.name.toLowerCase().endsWith('.csv')) {
      setFile(dropped);
    } else {
      setModalMensaje('Solo se aceptan archivos .csv');
      setSpinner(false);
      setModalDescarga(true);
    }
  };

  const handleUpload = async () => {
    if (!file) return;
    setSpinner(true);
    setModalMensaje('Procesando…');
    setModalDescarga(true);
    try {
      await reload.reloadCSV(file);
      setModalMensaje('Archivo subido con éxito');
      setSpinner(false);
    } catch (error) {
      setModalMensaje('Error al subir el archivo');
      setSpinner(false);
      console.error('Error al subir el archivo:', error);
    }
  };

  const extractTableData = (data) =>
    data.map((item) => ({
      fecha: item.fecha,
      pendientesSinError: item.pendientesSinError.cantidad,
      pendientesConError: item.pendientesConError.cantidad,
      faltantesbd: item.faltantes.cantidad,
    }));

  const getcsvPendientes = (data) => {
    const pendientesSinError = data.flatMap((item) =>
      item.pendientesSinError.documentos.map((doc) => ({
        fecha: item.fecha,
        folio: doc.folio,
        ticket: doc.ticket,
      })),
    );
    const pendientesConError = data.flatMap((item) =>
      item.pendientesConError.documentos.map((doc) => ({
        fecha: item.fecha,
        folio: doc.folio,
        ticket: doc.ticket,
        error: doc.error,
      })),
    );
    const faltantesbd = data.map((item) => ({
      fecha: item.fecha,
      tickets: item.faltantes.documentos.join(', '),
    }));
    setcsvPendientesConError(pendientesConError);
    setcsvPendientesSinError(pendientesSinError);
    setcsvFaltantesbd(faltantesbd);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const responseData = await resumensinc.getResumenSinc();
        if (responseData && Array.isArray(responseData.data.data)) {
          const tableData = extractTableData(responseData.data.data);
          getcsvPendientes(responseData.data.data);
          setformattedData(tableData);
        } else {
          console.error('El formato de los datos no es un arreglo:', responseData);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);

  const totals = formattedData
    ? formattedData.reduce(
        (acc, row) => ({
          sinError: acc.sinError + (row.pendientesSinError || 0),
          conError: acc.conError + (row.pendientesConError || 0),
          faltantes: acc.faltantes + (row.faltantesbd || 0),
        }),
        { sinError: 0, conError: 0, faltantes: 0 },
      )
    : null;

  const pendientesSinErrorHeaders = [
    { label: 'Fecha', key: 'fecha' },
    { label: 'Folio', key: 'folio' },
    { label: 'Ticket', key: 'ticket' },
  ];
  const pendientesConErrorHeaders = [
    { label: 'Fecha', key: 'fecha' },
    { label: 'Folio', key: 'folio' },
    { label: 'Ticket', key: 'ticket' },
    { label: 'Error', key: 'error' },
    { label: 'Origen', key: 'origen' },
  ];
  const faltantesbdHeader = [
    { label: 'Fecha', key: 'fecha' },
    { label: 'Tickets', key: 'tickets' },
  ];

  return (
    <>
      <div className="ResumenSinc">
        <div className="page-header">
          <h1 className="page-title">Sincronización Documentos</h1>
          <p className="page-subtitle">Sube archivos CSV y revisa el estado de la sincronización</p>
        </div>

        <Card className="search-card">
          <Card.Header className="search-card-header">
            <FaCloudUploadAlt className="me-2" />
            Subir archivo CSV
          </Card.Header>
          <Card.Body>
            <div
              className={`dropzone ${dragging ? 'dropzone-dragging' : ''} ${file ? 'dropzone-with-file' : ''}`}
              onClick={handleClick}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleClick(); }}
            >
              {file ? (
                <>
                  <FaFileCsv className="dropzone-icon dropzone-icon-success" />
                  <div className="dropzone-title">{file.name}</div>
                  <div className="dropzone-hint">{(file.size / 1024).toFixed(1)} KB · Listo para subir</div>
                </>
              ) : (
                <>
                  <FaCloudUploadAlt className="dropzone-icon" />
                  <div className="dropzone-title">Arrastra tu CSV aquí o haz clic para seleccionar</div>
                  <div className="dropzone-hint">Solo archivos .csv</div>
                </>
              )}
              <input
                type="file"
                accept=".csv"
                ref={hiddenFileInput}
                onChange={handleFileChange}
                style={{ display: 'none' }}
              />
            </div>

            <div className="upload-actions">
              <Button variant="primary" onClick={handleUpload} disabled={!file}>
                <FaCloudUploadAlt className="me-2" />Subir archivo
              </Button>
              {file && (
                <Button variant="outline-secondary" onClick={() => setFile(null)} className="ms-2">
                  Quitar
                </Button>
              )}
            </div>
          </Card.Body>
        </Card>

        {totals && (
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-icon stat-icon-warning"><FaCheckCircle /></div>
              <div>
                <div className="stat-value">{totals.sinError}</div>
                <div className="stat-label">Pendientes sin error</div>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon stat-icon-danger"><FaExclamationCircle /></div>
              <div>
                <div className="stat-value">{totals.conError}</div>
                <div className="stat-label">Pendientes con error</div>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon stat-icon-neutral"><FaDatabase /></div>
              <div>
                <div className="stat-value">{totals.faltantes}</div>
                <div className="stat-label">Faltantes en BD</div>
              </div>
            </div>
          </div>
        )}

        <Card className="search-card mt-4">
          <Card.Header className="search-card-header">
            <FaSyncAlt className="me-2" />
            Resumen por fecha
            {formattedData && formattedData.length > 0 && (
              <span className="results-count">{formattedData.length}</span>
            )}
          </Card.Header>
          <Card.Body className="p-0">
            {formattedData && formattedData.length > 0 ? (
              <div className="table-responsive">
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>Fecha</th>
                      <th className="text-end">Pendientes sin error</th>
                      <th className="text-end">Pendientes con error</th>
                      <th className="text-end">Faltantes en BD</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formattedData.map((row, idx) => (
                      <tr key={idx}>
                        <td className="nowrap">{row.fecha}</td>
                        <td className="text-end num">{row.pendientesSinError}</td>
                        <td className={`text-end num ${row.pendientesConError > 0 ? 'cell-danger' : ''}`}>
                          {row.pendientesConError}
                        </td>
                        <td className={`text-end num ${row.faltantesbd > 0 ? 'cell-danger' : ''}`}>
                          {row.faltantesbd}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="empty-state">
                <FaSyncAlt className="empty-state-icon" />
                <p className="empty-state-text">No hay datos de sincronización disponibles</p>
              </div>
            )}

            {(csvPendientesSinError?.length > 0 ||
              csvPendientesConError?.length > 0 ||
              csvFaltantesbd?.length > 0) && (
              <div className="download-strip">
                <span className="download-strip-label">
                  <FaDownload className="me-2" />Descargar detalle:
                </span>
                {csvPendientesSinError?.length > 0 && (
                  <CSVLink
                    data={csvPendientesSinError}
                    headers={pendientesSinErrorHeaders}
                    filename="pendientesSinError.csv"
                    className="btn btn-outline-primary btn-sm"
                  >
                    <FaFileCsv className="me-2" />Pendientes sin error
                  </CSVLink>
                )}
                {csvPendientesConError?.length > 0 && (
                  <CSVLink
                    data={csvPendientesConError}
                    headers={pendientesConErrorHeaders}
                    filename="pendientesConError.csv"
                    className="btn btn-outline-danger btn-sm"
                  >
                    <FaFileCsv className="me-2" />Pendientes con error
                  </CSVLink>
                )}
                {csvFaltantesbd?.length > 0 && (
                  <CSVLink
                    data={csvFaltantesbd}
                    headers={faltantesbdHeader}
                    filename="faltantes.csv"
                    className="btn btn-outline-secondary btn-sm"
                  >
                    <FaFileCsv className="me-2" />Faltantes en BD
                  </CSVLink>
                )}
              </div>
            )}
          </Card.Body>
        </Card>
      </div>

      <Modal show={modalDescarga} onHide={closeModal} centered>
        <Modal.Header closeButton={!spinner}>
          <Modal.Title>Subida de archivo</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center py-4">
          {spinner && <Spinner animation="border" variant="primary" className="mb-3" />}
          <div className="modal-message">{modalMensaje}</div>
        </Modal.Body>
        {!spinner && (
          <Modal.Footer>
            <Button variant="secondary" onClick={closeModal}>Cerrar</Button>
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
}

export default Resumensinc;
